import api from 'api';
import { useState } from 'react';
import { useGetCFLink } from './useGetCFLink';
import { decagonClient } from '../../services/decagonClient';
import { useFeatureFlag } from '@user-portal/experimentation';

export const useHandleContactRequest = () => {
    const link = useGetCFLink();
    const [isLoading, setIsLoading] = useState(false);

    const { value } = useFeatureFlag<{ visible: boolean }>({
        type: 'json',
        flagKey: 'cse-chatbot-toggle',
        defaultValue: { visible: false },
    });

    const openFallbackLink = () => window.open(link, '_blank');

    const onClick = async () => {
        if (value?.visible) {
            setIsLoading(true);
            try {
                if (decagonClient.isNotInitialised) {
                    const { token: handoffToken } = await api.user.getTokenHandoff();
                    await decagonClient.initialise({ handoffToken });
                }

                await decagonClient.open();
            } catch {
                openFallbackLink();
            } finally {
                setIsLoading(false);
            }
        } else {
            openFallbackLink();
        }
    };

    return { isLoading, onClick };
};
